'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { EVehicleS } from '@lichtblick/photon/icons/technology/e-vehicle-s';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import { useMemo } from 'react';
import { assertExhaustive } from '../../helpers/assertExhaustive';
import { RichText } from '../../helpers/RichText';
import { AImage } from '../AImage/AImage';
import { AVideo } from '../AVideo/AVideo';
import { MAnimatedIllustration } from '../MAnimatedIllustration/MAnimatedIllustration';
import styles from './o-info-dialog.module.scss';
const MediaContent = ({ content: contentList })=>{
    if (!contentList?.[0]) {
        return null;
    }
    const content = contentList[0];
    switch(content.component){
        case 'a-image':
            return /*#__PURE__*/ _jsx(AImage, {
                ...content
            });
        case 'a-video':
            return /*#__PURE__*/ _jsx(AVideo, {
                ...content
            });
        case 'm-animated-illustration':
            return /*#__PURE__*/ _jsx(MAnimatedIllustration, {
                ...content
            });
        default:
            assertExhaustive(content);
    }
};
const createElementMappers = (center)=>({
        h3: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
                align: center ? 'center' : undefined,
                className: styles.headline,
                renderAs: 'div',
                size: "s",
                children: children
            }),
        p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
                align: center ? 'center' : undefined,
                className: styles.text,
                children: children
            }),
        h6: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
                align: center ? 'center' : undefined,
                className: styles.h6,
                renderAs: 'div',
                size: "s",
                children: children
            })
    });
export const OInfoDialog = ({ ariaLabel, buttonText, headline, headlineIcon, isTextCentered = false, media, onSecondaryButtonClick, open, richText })=>{
    const elementMappers = useMemo(()=>{
        return createElementMappers(isTextCentered);
    }, [
        isTextCentered
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        "aria-label": ariaLabel,
        footerContent: /*#__PURE__*/ _jsx(TextCTA, {
            as: "button",
            onClick: onSecondaryButtonClick,
            children: buttonText
        }),
        isOpen: open,
        onPointerDownOutside: onSecondaryButtonClick,
        title: ariaLabel,
        children: [
            Boolean(headline) && /*#__PURE__*/ _jsxs("div", {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsx(Headline, {
                        align: isTextCentered ? 'center' : undefined,
                        renderAs: 'div',
                        size: "s",
                        children: headline
                    }),
                    Boolean(headlineIcon) && /*#__PURE__*/ _jsx(EVehicleS, {})
                ]
            }),
            Boolean(richText) && /*#__PURE__*/ _jsx(RichText, {
                elementMappers: elementMappers,
                richText: richText
            }),
            media?.length === 1 && /*#__PURE__*/ _jsx(MediaContent, {
                content: media
            })
        ]
    });
};

//# sourceMappingURL=OInfoDialog.js.map